import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, {
    nameDecorator,
    phoneDecorator,
} from '@r1-frontend/ui-react/components/inputSimple';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
// @ts-ignore
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Button = styled(BaseButton)`
  max-width: 200px;
  @media (max-width: 400px){
     max-width: unset;
  }
`;

export const NameInput = nameDecorator(InputSimple);

export const PhoneInput = styled(phoneDecorator(InputSimple))`
  width: 87%;
  @media (max-width: 400px){
    width: 100%;
  }
`;

export const BreakHack = styled.div`
  @media (min-width: 896px) {
    margin-left: 5px;
  }

  white-space: nowrap;
  display: inline;
`;

export const ButtonLookLikeHref = styled.div`
  display: inline;
  color: ${COLORS.Link};
  ${FONTS.MediumS};
  cursor: pointer;
  margin-left: 5px;
  transition: 0.3s;

  &:hover {
      color: ${COLORS.Brand_Blue};
  }
  
`;

export const Popup = styled(DefaultPopup)`
  border-radius: ${BorderRadius.OuterBlockRadius} !important;
  padding: 32px;
  display: flex;

  @media (max-width: 400px){
    padding: 26px;
  }
  @media (min-width: 760px){
    width: 700px !important;
  }
  @media (min-width: 900px){
    width: 800px !important;
  }
  @media (min-width: 1300px){
    width: 960px !important;
  }
  flex-direction: column;
  > * {
    margin-bottom: 20px;
  }
  > *:last-child{
    margin-bottom: unset;
  }
`;

export const ButtonsContainer = styled.div`
   display: flex;
   flex-direction: row;
   > * {
    margin-right: 12px;
    margin-top: 16px;
   }
`;

export const Title = styled.h1`
  ${FONTS.H3};
  margin-top: 0;
  margin-bottom: 10px;
`;

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 570px;
  @media (min-width: 400px){
    > * {
      margin-right: 12px;
      margin-bottom: unset;
    }
    > *:last-child {
      margin-right: unset;
    }
  }
  @media (max-width: 400px){
    flex-direction: column;
    align-items: center;
    > * {
      width: 100%;
      margin-bottom: 10px;
    }
    > *:last-child {
      margin-bottom: unset;
    }
  }
`;

export const InputContainer = styled(BaseContainer)`
    min-height: 72px;
    align-items: flex-start;
`;

export const Text = styled.div`
  align-items: baseline;
`;

export const PersText = styled.div`
  display: block;
  width: auto;
  ${FONTS.XS};
  > a {
    ${FONTS.MediumXS};
    display: inline;
    color: ${COLORS.TextPrimary};
    text-decoration: underline;
  }
`;

export const Message = styled.div<{ isError: boolean }>`
  color: ${props => props.isError ? COLORS.Error : COLORS.Success};
`;
